import { useCallback, useEffect, useState } from "react";
import "./index.scss";
import { BrandCallToAction } from "components/UI/atoms";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { ReactComponent as DollarSign } from "assets/dollar.svg";
import { ReactComponent as BellIcon } from "assets/bell-icon.svg";
import { URL_PARAMS } from "constants/urlParams";
import { setReturnToCookie } from "services/cookies";
import { BrandAlertModal } from "..";

export const BrandTrackAndSell = ({
  name,
  isLoggedIn = false,
  productSourceId
}) => {
  const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleTrackButtonClick = useCallback(() => {
    if (!isLoggedIn) {
      setReturnToCookie(window.location.href);
      navigate(INTERNAL_PATHS.USER_LOG_IN);
    }

    setAlertModalIsOpen(true);
  }, [navigate, isLoggedIn]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isForcedBrandAlert = urlParams.has(URL_PARAMS.BRAND_ALERT);

    if (isForcedBrandAlert) handleTrackButtonClick();
  }, [handleTrackButtonClick]);

  return (
    <>
      <div className="brand-track-and-sell" data-testid="brand-track-and-sell">
        <BrandCallToAction
          title={`Track ${name} Prices`}
          description={`Never miss a <bold>${name}</bold> deal! Get brand alerts sent to your inbox.`}
          buttonContent={
            <span>
              <BellIcon />
              <p>SET ALERT</p>
            </span>
          }
          onButtonClick={handleTrackButtonClick}
        />
        <hr />
        <BrandCallToAction
          title={`Have a ${name} Card?`}
          description="Earn up to 85% GCX Cash when you sell your gift card."
          buttonContent={
            <span>
              <DollarSign />
              <p>SELL GIFT CARD</p>
            </span>
          }
          onButtonClick={() => navigate(INTERNAL_PATHS.SELL_GIFT_CARDS)}
        />
      </div>

      {alertModalIsOpen && (
        <BrandAlertModal
          handleClose={() => setAlertModalIsOpen(false)}
          isOpen={alertModalIsOpen}
          productSourceId={productSourceId}
          name={name}
        />
      )}
    </>
  );
};
